import mapFunction from './mapResources';

export default mapFunction('building_entities', {
    isFetching: false,
    items: []
});